import { Module } from '@rxdi/core';

import { MarkdownParserService } from './markdown-reader.service';
import { MarkdownReaderComponent } from './markdown-reader/markdown-reader.component';
import { MarkdownParserMenuProvider } from './markdown-reader-menu.provider';
import { TocComponent } from './toc/toc.component';

@Module({
  components: [TocComponent, MarkdownReaderComponent],
  providers: [MarkdownParserService, MarkdownParserMenuProvider],
})
export class MarkdownReaderModule {}
